<template>
    <section class="home-container">
        <MasterPage title="面诊预约">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="100">
                    <Row>
                        <Col span="8">
                        <FormItem label="预约医生：">
                            <Select v-model="select.doctorId" clea  placeholder="请选择">
                                <Option v-for="item in doctorAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="患者用户：">
                            <Select v-model="select.userId"  placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="预约状态：">
                            <Select v-model="select.status" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="待处理">待处理</Option>
                                <Option value="预约成功">预约成功</Option>
                                <Option value="预约失败">预约失败</Option>
                                <Option value="取消">取消</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增预约" width="800" @on-cancel="cancelItem">
            <Form :label-width="80">
                <Row>
                    <Col span="8">
                    <FormItem label="预约医生：">
                        <Select v-model="itemAdd.doctorId" placeholder="请选择">
                            <Option v-for="item in doctorAllList"  :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="预约时间：">
                        <DatePicker v-model="itemAdd.time" type="datetime" placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="预约患者：">
                        <Select v-model="itemAdd.userId" filterable  placeholder="请选择">
                            <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改预约" width="800" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="预约时间：">
                    <DatePicker v-model="updateInfoItem.orderTime" type="datetime" placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                </FormItem>
                <FormItem label="会议链接：">
                    <Input v-model="updateInfoItem.meetingNumber" placeholder="请输入腾讯会议号，如：243 497 001" style="width: 100%" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="successModel" title="预约成功" width="800" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="期望时间：">
                    {{updateInfoItem.expectedTime | dateTimeToString}}
                </FormItem>
                <FormItem label="预约时间：">
                    <DatePicker v-model="updateInfoItem.orderTime" type="datetime" placeholder="请选择预约时间段" style="width: 100%"></DatePicker>
                </FormItem>
                <FormItem label="会议链接：">
                    <Input v-model="updateInfoItem.meetingNumber" placeholder="请输入腾讯会议号，如：243 497 001" style="width: 100%" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="deleteModel" title="取消原因" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="取消原因：">
                    <Input v-model="updateInfoItem.cancelReason" placeholder="请输入..." style="width: 100%" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '预约医生',
                        key: 'doctorName',
                        align: 'center',
                    },
                    {
                        title: '预约患者',
                        align: 'center',
                        render:(h, params) =>{
                            for (let i in this.userAllList) {
                                if (this.userAllList[i].id == params.row.userId) {
                                    return h("span",this.userAllList[i].name)
                                }
                            }
                        }
                    },
                    {
                        title: '期望时间',
                        align: 'center',
                        minWidth:50,
                        render:(h, params) =>{
                            let time = new Date(params.row.expectedTime)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hx = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h("span",y+'-'+m+'-'+d+' '+hx+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '预约时间',
                        align: 'center',
                        minWidth:50,
                        render:(h, params) =>{
                            if (params.row.status == '待处理') {
                                return h("span",'尚未处理')
                            }
                            if (!params.row.orderTime) {
                                return h("span",'无预约时间')
                            }
                            let time = new Date(params.row.orderTime)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hx = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h("span",y+'-'+m+'-'+d+' '+hx+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '预约状态',
                        key: 'status',
                        align: 'center',
                    },
                    {
                        title: '会议链接',
                        key: 'meetingNumber',
                        align: 'center',
                        minWidth: 120,
                        render: (h, params) => {
                            if (params.row.meetingNumber && params.row.meetingNumber != '') {
                                return h("span", params.row.meetingNumber)
                            } else {
                                return h("span", { style: { color: '#999' } }, '未设置')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = []
                            if (params.row.status == '取消') {
                                return h("span", '取消原因：' + params.row.cancelReason)
                            }
                            if (params.row.status == '待处理') {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            icon:'md-checkmark-circle-outline',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                this.updateInfoItem.status = '预约成功'
                                                this.successModel = true
                                            }
                                        }
                                    }, '成功')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'warning',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                this.updateInfoItem.status = '预约失败'
                                                this.updateItem()
                                            }
                                        }
                                    }, '失败')
                                )
                            }
                            if (params.row.status == '预约成功') {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '修改')
                                )
                            }
                            if (params.row.status != '取消' && params.row.status != '预约失败') {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateInfoItem = JSON.parse(JSON.stringify(this.dataList[params.index]))
                                                this.updateInfoItem.status = '取消'
                                                this.deleteModel = true
                                            }
                                        }
                                    }, '取消')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                successModel:false,
                deleteModel:false,
                userAllList:[],
                doctorAllList:[],
                select:{
                    userId:'',
                    doctorId:'',
                    status:'待处理',
                },
                itemAdd:{
                    doctorId:'',
                    time:'',
                    userId:'',
                },
                updateInfoItem:{},
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
            this.findAllDoctor()
        },
        methods:{
            dateTimeToStrings (dateTime) {
                let time = new Date(dateTime)
                let y = time.getFullYear();
                let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                let h = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                return y+'/'+m+'/'+d+' '+h+':'+mm+':'+s;
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllDoctor(){
                this.$http.post('doctor/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.doctorAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'医生列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('doctor/listOrder',{
                    userId:this.select.userId,
                    doctorId:this.select.doctorId,
                    status:this.select.status,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'预约列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                if (this.itemAdd.doctorId.length <= 0){
                    return this.$Message.warning('请选择预约医生');
                }
                if (this.itemAdd.time.length <= 0){
                    return this.$Message.warning('请选择预约时间');
                }
                if (this.itemAdd.userId.length <= 0){
                    return this.$Message.warning('请选择预约患者');
                }
                this.addLoading = true
                this.$http.post('doctor/order',{
                    doctorId: this.itemAdd.doctorId,
                    time: this.itemAdd.time ? this.itemAdd.time + ''  :null,
                    userId: this.itemAdd.userId,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '新增预约成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'新增预约失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item))
                this.updateInfoItem.orderTime = this.updateInfoItem.orderTime ? this.dateTimeToStrings(new Date(this.updateInfoItem.orderTime)) : null
                this.updateModel = true
            },
            updateItem(){
                this.updateLoading = true
                this.$http.post('doctor/updateOrder',
                    this.updateInfoItem,
                {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '修改预约成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'修改预约失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.successModel = this.deleteModel = false
                this.doctorId = this.time = this.userId = ''
            }
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>
